module.exports = __webpack_public_path__ + "static/img/que.b385158.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/que.png
// module id = ThsQ
// module chunks = 1